// Affiche "New" quand une valeur de variation (diff/rank) arrive sous forme NaN.
// Cas typique : une marque nouvelle n'a pas de donnée année précédente -> "NaN%".
export const displayNewIfNaN = (
  value: number | string | undefined | null
): string => {
  if (value === undefined || value === null) {
    return '';
  }
  const str = String(value).trim();
  // "NaN%", "NaN", ou toute valeur contenant "nan" (insensible à la casse)
  if (str === '' || /nan/i.test(str)) {
    return 'New';
  }
  return str;
};
